"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForm = void 0;
var react_1 = require("react");
function useForm(_a) {
    var initialValues = _a.initialValues, _b = _a.validationRules, validationRules = _b === void 0 ? {} : _b;
    var initialErrors = Object.keys(initialValues).reduce(function (acc, field) {
        acc[field] = false;
        return acc;
    }, {});
    var _c = react_1.useState(initialErrors), errors = _c[0], setErrors = _c[1];
    var _d = react_1.useState(initialValues), values = _d[0], setValues = _d[1];
    var resetErrors = function () { return setErrors(initialErrors); };
    var reset = function () {
        setValues(initialValues);
        resetErrors();
    };
    var validate = function () {
        var isValid = true;
        var validationErrors = Object.keys(values).reduce(function (acc, field) {
            if (validationRules &&
                typeof validationRules[field] === 'function' &&
                !validationRules[field](values[field])) {
                acc[field] = true;
                isValid = false;
            }
            else {
                acc[field] = false;
            }
            return acc;
        }, {});
        setErrors(validationErrors);
        return isValid;
    };
    var validateField = function (field) {
        return setErrors(function (currentErrors) {
            var _a;
            return (__assign(__assign({}, currentErrors), (_a = {}, _a[field] = typeof validationRules[field] === 'function'
                ? !validationRules[field](values[field])
                : false, _a)));
        });
    };
    var setFieldError = function (field, error) {
        return setErrors(function (currentErrors) {
            var _a;
            return (__assign(__assign({}, currentErrors), (_a = {}, _a[field] = error, _a)));
        });
    };
    var setFieldValue = function (field, value) {
        setValues(function (currentValues) {
            var _a;
            return (__assign(__assign({}, currentValues), (_a = {}, _a[field] = value, _a)));
        });
        setFieldError(field, false);
    };
    var onSubmit = function (handleSubmit) { return function (event) {
        event && event.preventDefault();
        validate() && handleSubmit(values);
    }; };
    return {
        values: values,
        errors: errors,
        validate: validate,
        reset: reset,
        setErrors: setErrors,
        setValues: setValues,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        validateField: validateField,
        resetErrors: resetErrors,
        onSubmit: onSubmit,
    };
}
exports.useForm = useForm;
